import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import { TruckJobRarity } from '../AppTruckJob/AppTruckJob.model';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledTopContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const StyledHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const StyledOrderTag = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 20px;
	padding: 0 5px;
	border-radius: 5px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
	}

	&.${TruckJobRarity.COMMON} {
		background-color: rgba(255, 255, 255, 0.05);
	}
	&.${TruckJobRarity.UNCOMMON} {
		background-color: #2d70da;
	}
	&.${TruckJobRarity.RARE} {
		background-color: #9948ff;
	}
	&.${TruckJobRarity.EPIC} {
		background-color: #fabe2c;

		${Text} {
			color: #000000;
		}
	}
	&.${TruckJobRarity.LEGENDARY} {
		background-color: #eb1818;
	}
`;

const StyledTimeTag = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 5px;
	height: 20px;
	padding: 0 5px;
	border-radius: 5px;
	background-color: #ffbb00;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #000000;
	}
`;

const StyledTagsContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledMapContainer = styled.div`
	position: relative;
	height: 229px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
`;

const StyledMapCaption = styled.div`
	position: absolute;
	bottom: 20px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	height: 30px;
	padding: 0 10px;
	border-radius: 10px;
	background-color: #2d70da;

	${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	margin-top: 10px;
`;

const StyledInfoHeadContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-weight: 500;
		font-size: 16px;
		color: rgba(255, 255, 255, 0.75);
	}
`;

const StyledInfoItemContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	& > ${Text} {
		&:first-child {
			font-size: 14px;
			color: #ffffff;
			opacity: 0.25;
		}
	}
`;

const StyledInfoTimeContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;

	${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #ffbb00;
	}
`;

const StyledInfoPriceContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledBottomContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 50px;
	gap: 20px;
	margin-top: 10px;
`;

const StyledOrderProgressContainer = styled.div`
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 15px;
	background-color: rgba(255, 187, 0, 0.1);
	border: 1px solid #ffbb00;
	border-radius: 10px;
`;

const StyledOrderProgressStepsContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledOrderProgressStep = styled.div<{ $completed?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	border-radius: 20px;
	background-color: ${({ $completed }) =>
		$completed ? '#FFBB00' : 'rgba(255, 255, 255, 0.02)'};
	border: 1px solid
		${({ $completed }) =>
			$completed ? '#FFBB00' : 'rgba(255, 255, 255, 0.05)'};

	.img-icon {
		background-color: ${({ $completed }) =>
			$completed ? '#000000' : 'rgba(255, 255, 255, 0.25)'};
	}
`;

const StyledOrderProgressBarWrapper = styled.div`
	position: relative;
	width: 30px;
	height: 10px;
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;
	padding: 1px;
`;

const StyledOrderProgressBar = styled.div`
	height: 6px;
	border-radius: 5px;
	background-color: #ffbb00;
`;

export {
	StyledBottomContainer,
	StyledContainer,
	StyledHeader,
	StyledInfoContainer,
	StyledInfoHeadContainer,
	StyledInfoItemContainer,
	StyledInfoPriceContainer,
	StyledInfoTimeContainer,
	StyledMapCaption,
	StyledMapContainer,
	StyledOrderProgressBar,
	StyledOrderProgressBarWrapper,
	StyledOrderProgressContainer,
	StyledOrderProgressStep,
	StyledOrderProgressStepsContainer,
	StyledOrderTag,
	StyledTagsContainer,
	StyledTimeTag,
	StyledTopContainer,
};
